import React from 'react'

export type ThemeMode = 'light' | 'dark'

const STORAGE_KEY = 'mode'

const readInitialMode = (): ThemeMode => {
  if (typeof window === 'undefined') return 'dark'
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return stored === 'light' ? 'light' : 'dark'
  } catch {
    return 'dark'
  }
}

export const useThemeMode = (): [ThemeMode, () => void] => {
  const [mode, setMode] = React.useState<ThemeMode>(readInitialMode)

  React.useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode)
    } catch {}
  }, [mode])

  const toggleMode = React.useCallback(() => {
    setMode(prev => (prev === 'dark' ? 'light' : 'dark'))
  }, [])

  return [mode, toggleMode]
}

export default useThemeMode

